<template>
  <v-app>
    <v-container fluid class="error-page">
      <v-row class="logo-wrapper">
        <v-img src="@/assets/img/logo.svg" contain width="225"></v-img>
<!--        <span class="logo-title">Vue Material Admin</span>-->
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="8">
          <div class="card">
            <span class="error-logo">404</span>
              <p class="error-text"> Упс! Ошибка загрузки страницы. Похоже, что страница, которую вы ищете больше не существует.</p>
              <p class="error-subtext">Не переживайте, мы поможем Вам вернуться на домашнюю страницу.</p>
            <v-btn
              class="text-capitalize primary"
              dark
              x-large
              :color="config.light.primary"
              :to="{name: 'Main'}">
                Назад на главную
            </v-btn>
          </div>
        </v-col>
      </v-row>
  </v-container>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'Error',
  data(){
    return{
      config
    }
  }
};
</script>

<style src="./Error.scss" lang="scss"></style>
